export const eventQueryKeys = {
  all: ["EVENT_DETAIL"],
  getEventDetail: (options?: object) => [...eventQueryKeys.all, { options }],
  getEventComments: (options?: object) => [
    ...eventQueryKeys.all,
    "COMMENTS",
    { options },
  ],
  getCommentReplies: (options?: object) => [
    ...eventQueryKeys.all,
    "COMMENTS_REPLIES",
    { options },
  ],
  getHostReviewList: (options?: object) => [
    ...eventQueryKeys.all,
    "HOST_REVIEW_LIST",
    { options },
  ],
  getMyReview: (options?: object) => [
    ...eventQueryKeys.all,
    "MY_REVIEW",
    { options },
  ],
  getEventUserList: (options?: object) => [
    ...eventQueryKeys.all,
    "USER_LIST",
    { options },
  ],
  getRecentNoShowEvent: (options?: object) => [
    ...eventQueryKeys.all,
    "NO_SHOW_EVENT",
    { options },
  ],
};
